/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSurveyInitializedEvent = (event) => event['type'] === 'WEB_CHAT_SURVEY_RATING_QUESTION';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSurveyRatingResponseEvent = (event) => event['type'] === 'WEB_CHAT_SURVEY_RATING_RESPONSE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSurveyFeedbackQuestionEvent = (event) => event['type'] === 'WEB_CHAT_SURVEY_FEEDBACK_QUESTION';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSurveyFeedbackResponseEvent = (event) => event['type'] === 'WEB_CHAT_SURVEY_FEEDBACK_RESPONSE';
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSurveyRatingEvent = (event) => isWebChatSurveyInitializedEvent(event) || isWebChatSurveyRatingResponseEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSurveyFeedbackEvent = (event) => isWebChatSurveyFeedbackQuestionEvent(event) || isWebChatSurveyFeedbackResponseEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSurveyEvent = (event) => isWebChatSurveyFeedbackEvent(event) || isWebChatSurveyRatingEvent(event);
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
export const isWebChatSmartResponseEvent = (event) => event['type'] === 'WEB_CHAT_SMART_RESPONSE_SELECT_QUESTION';
//# sourceMappingURL=types.js.map